module.exports = __webpack_public_path__ + "img/guatemala.d5268137.svg";